/**
 * Adds a change event handler when the outlet for an additional field is connected. When a specified option is chosen
 * from the tom-select dropdown, an additional text field is revealed for the user to fill out.
 *
 * Example:
 *
 * -# The tom-select dropdown:
 * = form.select :nu_community_id, form_community_options, {},
 *               class: "additional-field-select",
 *               data: { controller: "select" }
 *
 * -# The additional field to be revealed when the option "Other" is selected from the tom-select:
 * %div{ data: { controller: "select-additional-field",
 *               "select-additional-field-select-outlet": ".additional-field-select",
 *               "select-additional-field-matching-text-value": NuCommunity::OTHER_COMMUNITY } }
 *   = form.text_field :nu_community_other
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { matchingText: String };
  static outlets = ["search-select"];

  searchSelectOutletConnected(outlet, element) {
    this.boundToggleVisibilityHandler = this.toggleVisibilityHandler.bind(this);
    element.addEventListener("change", this.boundToggleVisibilityHandler);
  }

  searchSelectOutletDisconnected(outlet, element) {
    element.removeEventListener("change", this.boundToggleVisibilityHandler);
  }

  toggleVisibilityHandler() {
    const selectedOptionText = this.searchSelectOutlet.element.selectedOptions[0].text;
    const matchingTextValueSelected = selectedOptionText === this.matchingTextValue;
    this.element.classList.toggle("d-block", matchingTextValueSelected);
    this.element.classList.toggle("d-none", !matchingTextValueSelected);
  }
}
